export const TYPE_SCALE_PX = { xs: 11, sm: 13, md: 14, lg: 20, xl: 28 } as const;

export type TypeScaleStep = keyof typeof TYPE_SCALE_PX;

export const TYPE_SCALE_SIZES: readonly number[] = Object.values(TYPE_SCALE_PX);

export function fontSizeVar(step: TypeScaleStep): string {
  return `var(--fs-${step})`;
}
